// Libs
import React, { Component } from 'react'
import classNames from 'classnames'

// CSS
import './styles.scss'

// Components/Containers
import CloseIcon from '../CloseIcon'

class Select extends Component {
  state = {
    visible: false,
    index: 0,
    options: [],
    scrollTop: 0,
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { disabled } = nextProps

    if (disabled) {
      this.setState({
        visible: false,
      })
    }
  }

  clearInput = (e) => {
    const { input: { onChange }, options, handleClear } = this.props

    onChange('')
    handleClear && handleClear()

    this.setState({
      visible: false,
      options
    })
  }

  clickOption = (e) => {
    const { input: { onChange }, handleSelect } = this.props
    const { attributes: { id } } = e.target
    const { options } = this.state

    // Filter options if match the target attr id
    let optionSelected = options.filter(option => {
      return option.id.toString() === id.value.toString() ? option : null
    })

    optionSelected = optionSelected[0]

    onChange(optionSelected.value)
    handleSelect && handleSelect(optionSelected)

    this.setState({
      visible: false,
    })
  }

  createOption = (e) => {
    const { handleCreate } = this.props

    handleCreate(true)

    this.setState({
      visible: false,
    })
  }

  filterOptions = (e) => {
    const { options } = this.props

    // Create a regex
    var regex = new RegExp(e.target.value, 'i');

    // Filter options if matches the regex
    const optionsFiltered = options.filter(option => {
      return option.value.match(regex)
    })

    this.setState({
      options: optionsFiltered,
    })
  }

  handleKeyDown = (e) => {
    const { input: { onChange }, handleSelect } = this.props
    const { visible, options, scrollTop, index } = this.state
    const optionsContainer = this.refs.optionsContainer

    switch (true) {
      case visible && e.keyCode === 13:
        onChange(options[index].value)
        handleSelect && handleSelect(options[index])

        this.setState({
          visible: false,
          index: 0,
          scrollTop: 0,
        })

        e.preventDefault();
        break;
      case visible && e.keyCode === 9:
        e.preventDefault();
        break;
      case !visible && (e.keyCode === 13 || e.keyCode === 9):
        this.setState({
          visible: false,
        })
        break;
      case e.keyCode === 38:
        const indexSub = index - 1
        const optionSub = this.refs[`option${indexSub}`]

        if (optionSub) {
          optionsContainer.scrollTop = scrollTop - optionSub.offsetHeight
          this.setState({
            scrollTop: scrollTop - optionSub.offsetHeight
          })
        }

        this.setState({
          visible: true,
          index: index !== 0 ? index - 1 : index
        })
        break;
      case e.keyCode === 40:
        const indexAdd = index + 1
        const optionAdd = this.refs[`option${indexAdd}`]

        if (optionAdd) {
          optionsContainer.scrollTop = scrollTop + optionAdd.offsetHeight
          this.setState({
            scrollTop: scrollTop + optionAdd.offsetHeight
          })
        }

        this.setState({
          visible: true,
          index: index < (options.length - 1) ? index + 1 : index,
        })
        break;
      default:
        this.setState({
          visible: true,
        })
        break;
    }
  }

  handleBlur = (e) => {
    const { input: { onBlur } } = this.props
    const { options } = this.state
    const { clickOption } = this
    const { value } = e.target

    if (options.length === 1 && value === options[0].value) {
      const e = { target: { attributes: { id: { value: options[0].id } } } }

      clickOption(e)
    }

    // TODO: Temporary solution to prevent from not click
    setTimeout(() => this.setState({ visible: false }), 200)
    onBlur(e)
  }

  render() {
    const {
      input,
      meta: {
        touched,
        error,
      },
      label,
      placeholder,
      disabled,
      gutter,
      createLabel,
      handleCreate,
    } = this.props
    const { visible, options, index } = this.state

    const selectStyle = {
      margin: `${gutter / 2}px 0px`
    }

    const closeIconClassName = classNames(
      'select__close-icon',
      {
        'select__close-icon--visible': !disabled && input.value
      }
    )

    const selectInputClassName = classNames(
      'select__input',
      {
        'select__input--err': !visible && touched && error,
        'select__input--disabled': disabled
      }
    )

    const selectOptionsClassName = classNames(
      'select__options',
      {
        'select__options--visible': visible
      }
    )

    const selectNotFoundClassName = classNames(
      'select__not-found',
      {
        'select__not-found--visible': !handleCreate && options.length === 0
      }
    )

    const selectCreateClassName = classNames(
      'select__create',
      {
        'select__create--visible': handleCreate
      }
    )

    return (
      <div style={selectStyle} className="select">
        <div className="select__label">{label}</div>
        <div className="select__wrapper">
          <input
            {...input}
            autoComplete="none"
            placeholder={placeholder}
            disabled={disabled}
            className={selectInputClassName}
            onBlur={this.handleBlur}
            onKeyUp={this.filterOptions}
            onKeyDown={this.handleKeyDown} />
          <div onClick={this.clearInput} className={closeIconClassName}>
            <CloseIcon width={15} />
          </div>
        </div>
        <div className="select__content">
          <ul className={selectOptionsClassName} ref="optionsContainer">
            {options.map((option, optionIndex) => (
              <li
                id={option.id}
                key={optionIndex}
                ref={`option${optionIndex}`}
                className={optionIndex === index ? 'select__option select__option--hover' : 'select__option'}
                onClick={this.clickOption}>
                {option.value}
              </li>
            ))}
            <li className={selectNotFoundClassName}>Não Encontrada</li>
            <li className={selectCreateClassName} onClick={this.createOption} >{createLabel}</li>
          </ul>
        </div>
        {!visible && touched && error && <p className="select__err">{error}</p>}
      </div>
    )
  }
}

export default Select
